<form id="voucher-block" class="form-control-wrapper form-width-52" [formGroup]="voucherInputFormGroup">
    <mat-form-field hideRequiredMarker>
        <mat-label>{{ 'PARTY.CASHIER.web.deposit.flash1voucher.voucher.label' | translate }}</mat-label>
        <input
            matInput
            digitOnly
            type="tel"
            formControlName="voucherInput"
            id="voucherInput"
            [(ngModel)]="depositService.depositInfo.paymentAccountInfo.voucherNumber"
            minlength="16"
            maxlength="16"
            (input)="validateVoucherInput()" />
        @if (
            voucherInputFormGroup?.controls?.voucherInput?.invalid ||
            (voucherInputFormGroup?.controls?.voucherInput?.touched && voucherInputFormGroup?.controls?.voucherInput?.dirty)
        ) {
            <mat-error>
                @if (voucherInputFormGroup?.controls?.voucherInput?.errors?.required) {
                    <div>{{ 'PARTY.CASHIER.web.deposit.flash1voucher.voucher.required' | translate }}</div>
                } @else if (voucherInputFormGroup?.controls?.voucherInput?.errors?.minlength) {
                    <div>{{ 'PARTY.CASHIER.web.deposit.flash1voucher.voucher.required' | translate }}</div>
                }
            </mat-error>
        }
    </mat-form-field>

    @if (
        (voucherInputFormGroup.controls.voucherInput.dirty || voucherInputFormGroup.controls.voucherInput.touched) &&
        flashVoucherErrorDetails?.errorCode
    ) {
        <show-message [type]="messageType.ERROR">
            <div error>
                @if (flashVoucherErrorDetails?.errorCode === '2400') {
                    <p>
                        {{ 'PARTY.CASHIER.web.deposit.flash1voucher.declined.expired.error.text' | translate }}
                    </p>
                } @else if (flashVoucherErrorDetails?.errorCode === '2401') {
                    <p>
                        {{ 'PARTY.CASHIER.web.deposit.flash1voucher.declined.already.redeemed.error.text' | translate }}
                    </p>
                } @else if (flashVoucherErrorDetails?.errorCode === '2402') {
                    <p>
                        {{ 'PARTY.CASHIER.web.deposit.flash1voucher.declined.invalid.number.error.text' | translate }}
                    </p>
                }
            </div>
        </show-message>
    }
</form>
